type CollectionLinkType =
  | 'challenge'
  | 'programDeepLink'
  | 'programLandingPage'
  | 'channelLandingPage'
  | 'subscriptionCheckoutPage'
  | 'checkoutPage'
  | 'giftingPage'
  | 'channelDeepLink';

const collectionLinks: Record<
  CollectionLinkType,
  { title: string; description: string }
> = {
  challenge: {
    title: 'Challenge deep link',
    description:
      'Use this link to direct users to the challenge inside the app.',
  },
  programDeepLink: {
    title: 'Program Deep Link',
    description:
      'A link that directs users straight to the app giving them a glimpse of your program',
  },
  programLandingPage: {
    title: 'Program Landing Page',
    description:
      "Use this link to direct users to your Program's Landing page, with the full context of your program",
  },
  channelLandingPage: {
    title: 'Channel Landing Page',
    description:
      "Use this link to direct users to your Channel's Landing page. Use this link to launch your app.",
  },
  subscriptionCheckoutPage: {
    title: 'Subscription Checkout Page',
    description:
      'Links a user straight to where they can check out and purchase your monthly or annual Subscription',
  },
  checkoutPage: {
    title: 'Program Checkout Page',
    description:
      'Links a user straight to where they can check out and purchase your program',
  },
  giftingPage: {
    title: 'Gifting Link',
    description:
      'This link can be used by your users to purchase/gift an annual subscription for another user ',
  },
  channelDeepLink: {
    title: 'Channel Deep Link',
    description:
      'A link that directs users straight to the app giving them a glimpse of your channel',
  },
};

export const toCollectionLink = (
  type: keyof typeof collectionLinks,
  url: string | undefined | null,
): { title: string; url: string; description: string } | undefined => {
  if (!url) return undefined;
  const link = collectionLinks[type];

  if (!link) return undefined;
  return {
    title: link.title,
    url: url,
    description: link.description,
  };
};
